import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import store, { persistor } from "./redux/store";
import { AuthProvider } from "./auth/AuthContext";
import "./i18n";
import { SnackbarProvider } from "./context/ShowMessage";
import { BrowserRouter } from "react-router-dom";
import "@fontsource/poppins"; // Default weight (400)
import "@fontsource/poppins/400.css"; // Specify weight
import "@fontsource/poppins/500.css"; // Medium weight
import "@fontsource/poppins/700.css"; // Bold weight

if (typeof window !== "undefined" && HTMLElement.prototype.focus) {
  const originalFocus = HTMLElement.prototype.focus;
  HTMLElement.prototype.focus = function (options?: FocusOptions): void {
    const isTargetElement =
      this.tagName === "INPUT" ||
      (this.classList && this.classList.contains("MuiPickersPopper-root")) ||
      (typeof this.closest === "function" && this.closest(".MuiPickersPopper-root"));

    if (isTargetElement) {
      originalFocus.call(this, { ...options, preventScroll: true });
    } else {
      originalFocus.call(this, options);
    }
  };
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <BrowserRouter>
        <AuthProvider>
          <SnackbarProvider>
            <App />
          </SnackbarProvider>
        </AuthProvider>
      </BrowserRouter>
    </PersistGate>
  </Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
